export function encodeQueryStringParams(params: Record<string, string>) {
  return Object.keys(params)
    .map((param) => `${param}=${encodeURIComponent(params[param])}`)
    .join("&");
}
